import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { Spin } from "antd";
import { useSnackbar } from "notistack";
import { LoadingOutlined } from "@ant-design/icons";
import { connect, useSelector } from "react-redux";
import pic from "../assets/images/pwd.png";
import { storeForgotPasswordAction } from "../redux/action/recoverPasswordAction";

function ForgotPasswordStore({ storeForgotPasswordAction }) {
  const [email_success, setEmailSuccess] = useState(false);
  const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;
  const { email_loader } = useSelector(
    (state) => state.recoverPassword
  );
  const { enqueueSnackbar } = useSnackbar();
  const [state, setState] = useState({
    email: "",
  });

  const history = useHistory();

  // const { id, token } = useParams(); // Id and Token destructured to get the id and token from the route params

  const { email } = state;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState({
      ...state,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    try {
      storeForgotPasswordAction(state).then((res) => {
        if(res.status) {
          setEmailSuccess(true)
          enqueueSnackbar(res?.message || "Please check your mail", {
            variant: "success",
            vertical: "top",
            horizontal: "right",
          });
          // Clear the input field
          setState({
            email: "",
          });
        } else {
          enqueueSnackbar(res?.message || "OOps, Something went wrong", {
            variant: "error",
            vertical: "top",
            horizontal: "right",
          });
        }
      })
    } catch(err) {
      enqueueSnackbar("Unexpected Error", {
        variant: "error",
        vertical: "top",
        horizontal: "right",
      });
      
    }
  };
  return (
    <div
      style={{
        background: "#FAFAFB",
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        padding: "0 5%",
      }}
    >
      <div className="fgtpwd">
        <div className="fgtpwd__container">
          <p className="fgtpwd__title">
            {" "}
            <img src={pic} alt="" /> FORGOT PASSWORD
          </p>

          <form onSubmit={handleSubmit}>
            <label>Email</label>
            <input
              type="email"
              placeholder="email@example.com"
              name="email"
              required
              value={email}
              onChange={handleChange}
            />
            <br />

            <div className="auth">
              <p>
                Remember Password?
                <span className="auth-p">
                  <Link to="#" onClick={() => history.goBack()}> Go back </Link>
                </span>
              </p>
              <button disabled={email_loader}>
                {email_loader ? <Spin indicator={antIcon} /> : "Reset Password"}
              </button>
            </div>
          </form>
        </div>
      </div>
      {email_success && (
        <p className="fgtpwd__p">
          Please check your email to complete password reset
        </p>
      )}
    </div>
  );
}

const mapDispatchToProps = (dispatch) => {
  return {
    storeForgotPasswordAction: (payload) => dispatch(storeForgotPasswordAction(payload)),
  };
};

export default connect(null, mapDispatchToProps)(ForgotPasswordStore);
